import { writable } from 'svelte/store';

const initialCallObj = { count: 0, firstTS: 0, lastTS: 0 };

const createDataCallsStore = () => {
	const { subscribe, set, update } = writable(initialCallObj);

	return {
		subscribe,
		customUpdate: (timeStamp) => {
			update((currState) => {
				return {
					count: currState.count++,
					firstTS: currState.firstTS === 0 ? timeStamp : currState.firstTS,
					lastTS: timeStamp,
				};
			});
		},
		reset_list: () => set(initialCallObj),
	};
};

export const refreshDataCalls = createDataCallsStore();
